const DWELL_LOGGING_PATH = "/m/rpc/dwell/log";

export interface LogViewjobDwellRestParams {
  tk?: string | null;
  duration: number;
  endTime: number;
  hasApplyStart: boolean;
  accountKey?: string | null;
  jobKey?: string | null;
}

export function logViewjobDwellRest({
  tk,
  duration,
  endTime,
  hasApplyStart,
  accountKey,
  jobKey,
}: LogViewjobDwellRestParams): void {
  if (!tk) {
    return;
  }

  const searchParams = new URLSearchParams({
    tk,
    pg: "desktopVj",
    d: String(duration),
    et: String(endTime),
    hasApplyStart: String(hasApplyStart),
  });

  if (accountKey) {
    searchParams.set("ak", accountKey);
  }
  if (jobKey) {
    searchParams.set("jk", jobKey);
  }

  void fetch(`${DWELL_LOGGING_PATH}?${searchParams}`, {
    method: "GET",
    keepalive: true,
  }).catch(() => {});
}
